import { render, staticRenderFns } from "./Blacksmith.vue?vue&type=template&id=12ac3a53&scoped=true&"
import script from "./Blacksmith.vue?vue&type=script&lang=ts&"
export * from "./Blacksmith.vue?vue&type=script&lang=ts&"
import style0 from "./Blacksmith.vue?vue&type=style&index=0&id=12ac3a53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac3a53",
  null
  
)

export default component.exports